// extracted by mini-css-extract-plugin
export default {"bodyText":"VZVvpq6deRE9pvXIIMqN","cancelBtn":"juX_lC1VIHPClQf88Unw","confirmBtn":"QBylCBmG_aV_862Yye03"};